import axios from 'axios';
import { useState, useEffect } from 'react';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';
import useDebounce from '../../../../hooks/useDebounce';

const useGetData = () => {
  const date = useQuery('date');
  const [moduleData, setModuleData] = useState<any>([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [render, setParentRender] = useState(false);
  const [renderforUpdate, setRenderforUpdate] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [breakdownData, setBreakdownData] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const [tableData, setTableData] = useState<any[]>([]);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const page = useQuery('page') || 1;

  
  useEffect(() => {
    axios
      .get('/api/machineRoutes/machine/ForAutocomplete')
      .then((res) => {
        setMachineData(res.data);
      })
      .catch((err) => console.log(err));
    axios
      .get('/api/masterListOfBreakdown/breakdownList/breakdownForAutoComplete')
      .then((res) => {
        setBreakdownData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (!date) return;
    console.log("tabValue", tabValue)
    const handleApi = async () => {
      setIsLoading(true);
      if(tabValue==0||tabValue==1){
        axios
        .get(`${moduleConstant.apiConstant}/${date}?tab=${tabValue}`)
        .then((response) => {
          setModuleData(response?.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setModuleData([]);
          setError(err);
        });
      }
      if(tabValue==2){
      axios
        .get(`${moduleConstant.apiConstant}/dashboard/getDownTimeByMonthly/${date}`)
        .then((response) => {
          setModuleData(response?.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setModuleData([]);
          setError(err);
        });
      }
    };

    handleApi();
    setIsLoading(false);
  }, [date, renderforUpdate, tabValue]);

 
  // const fetchData = async () => {
  //   if (!date) return;
  
  //   axios
  //     .get(`/api/machineMaintenanceWOAndReceiptRoute/monthly/${date}?page=${page}&perPage=${perPage}`)
  //     .then((res) => {
  //       console.log("res?.data?.results is ", res?.data?.results);
  
  //       // Filter the results based on tabValue
  //       const filteredData = res?.data?.results?.filter((item:any) => {
  //         if (tabValue === 0) {
  //           // Show only data with defect_id.type === 'MECHANICAL'
  //           return item?.defect_id?.type === 'MECHANICAL';
  //         } else if (tabValue === 1) {
  //           // Example: Show data with defect_id.type === 'ELECTRICAL' for tabValue 1
  //           return item?.defect_id?.type === 'ELECTRICAL';
  //         } else {
  //           // Return all data if no specific filter is applied
  //           return true;
  //         }
  //       });
  
  //       setModuleData(filteredData);
  //       setPerPage(res?.data?.perPage);
  //       setTotalPages(res?.data?.pages);
  //     })
  //     .catch((err) => console.log(err));
  // };
  
  // Use useDebounce to debounce the fetchData function
  // useDebounce(fetchData, 500, [page, render, date, tabValue]);
  

  // useDebounce(fetchData, 500, [page, render, date,tabValue]);

  return {
    error,
    moduleData,
    setModuleData,
    isLoading,
    setParentRender,
    setRenderforUpdate,
    machineData,
    breakdownData,
    tabValue,
    setTabValue,
    totalPages,
  };
};

export default useGetData;
